import { FC } from "react";
import { IconPropsType } from ".";

export const Navigate: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 12V1.5M1 3.5L3.5 1L6 3.5"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4.5L11 7L8.5 9.5"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12V11C3.5 8.79086 5.29086 7 7.5 7H9.5"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
